/**
 * @description: 充公汇总报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="war-cgh-report">
        <div class="ch-list">
            <el-form :inline="true" size="small" :model="ch_list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="ch_list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="ch_list_form.start_date"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="ch_list_form.end_date"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="ch_list_form.shop_id" filterable clearable placeholder="请选择门店" @change="getRoomArea">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="区域" v-show="ch_sortby == 'room_area'">
                    <el-select v-model="ch_list_form.room_area_name" filterable clearable placeholder="请选择区域" :disabled="ch_list_form.room_area_disabled" @change="chRoomArea">
                        <el-option v-for="item in room_area_list" :key="item.id" :label="item.name" :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品类型">
                    <el-select v-model="ch_list_form.goods_type" filterable clearable placeholder="请选择商品类型">
                        <el-option v-for="item in goods_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品名称">
                    <el-input v-model="ch_list_form.goods_name" placeholder="请输入商品名称"></el-input>
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input v-model="ch_list_form.mobile" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="chQuery">查询</el-button>
                    <el-button @click="chExportSet">导出</el-button>
                    <el-button class="ch-type el-button--primary" @click="chSortBy('goods')">按商品统计</el-button>
                    <el-button class="ch-type" @click="chSortBy('room_area')">按区域统计</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="ch_list">
                <el-table-column type="index" label="行号"></el-table-column>
                <el-table-column width="130" label="门店">
                    <template slot-scope="scope">
                        {{scope.row.shop_name.length > '14' ? scope.row.shop_name.slice(0, 14) + '...' : scope.row.shop_name}}
                    </template>
                </el-table-column>
                <el-table-column prop="area_name" label="包厢区域" v-if="ch_sortby == 'room_area'"></el-table-column>
                <el-table-column prop="goods_type_name" label="商品类型"></el-table-column>
                <el-table-column width="130" label="商品名称">
                    <template slot-scope="scope">
                        {{scope.row.goods_name.length > '14' ? scope.row.goods_name.slice(0, 14) + '...' : scope.row.goods_name}}
                    </template>
                </el-table-column>
                <el-table-column prop="goods_unit_name" label="单位"></el-table-column>
                <el-table-column prop="in_quantity" label="充公入库总量"></el-table-column>
                <el-table-column prop="out_quantity" label="充公出库总量"></el-table-column>
                <el-table-column prop="buying_price" label="进货单价"></el-table-column>
                <el-table-column prop="buying_price_total" label="进货价合计"></el-table-column>
            </el-table>
            <div class="pagination-row">
                <div>
                    <label class="list-label-6">充公入库总量:</label>
                    <div class="list-total">{{ch_total_in_quantity}}</div>
                    <label class="list-label-6">充公出库总量:</label>
                    <div class="list-total">{{ch_total_out_quantity}}</div>
                    <label class="list-label-4">进货总价:</label>
                    <div class="list-total">{{ch_buying_price_total}}</div>
                </div>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="ch_list_page"
                    :total="ch_list_total"
                    @current-change="getChList">
                </el-pagination>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="export-wrap" ref="ch_list_export">
                <div v-show="ch_sortby == 'goods'">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <el-checkbox :indeterminate="ch_export_sign1" v-model="ch_export_all1" @change="chExportAll">全选</el-checkbox>
                    <el-checkbox-group v-model="ch_export_ids1" @change="chExportChange">
                        <el-checkbox label="shop_name">门店</el-checkbox>
                        <el-checkbox label="goods_type_name">商品类型</el-checkbox>
                        <el-checkbox label="goods_name">商品名称</el-checkbox>
                        <el-checkbox label="goods_unit_name">单位</el-checkbox>
                        <el-checkbox label="in_quantity">充公入库总量</el-checkbox>
                        <el-checkbox label="out_quantity">充公出库总量</el-checkbox>
                        <el-checkbox label="buying_price">进货单价</el-checkbox>
                        <el-checkbox label="buying_price_total">进货价合计</el-checkbox>
                    </el-checkbox-group>
                    <h3>请选择导出报表的文件格式</h3>
                    <el-radio v-model="ch_export_type1" label="1">excel表格</el-radio>
                    <el-radio v-model="ch_export_type1" label="2">pdf文件</el-radio>
                </div>
                <div v-show="ch_sortby == 'room_area'">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <el-checkbox :indeterminate="ch_export_sign2" v-model="ch_export_all2" @change="chExportAll">全选</el-checkbox>
                    <el-checkbox-group v-model="ch_export_ids2" @change="chExportChange">
                        <el-checkbox label="shop_name">门店</el-checkbox>
                        <el-checkbox label="goods_type_name">商品类型</el-checkbox>
                        <el-checkbox label="goods_name">商品名称</el-checkbox>
                        <el-checkbox label="goods_unit_name">单位</el-checkbox>
                        <el-checkbox label="in_quantity">充公入库总量</el-checkbox>
                        <el-checkbox label="out_quantity">充公出库总量</el-checkbox>
                        <el-checkbox label="buying_price">进货单价</el-checkbox>
                        <el-checkbox label="buying_price_total">进货价合计</el-checkbox>
                    </el-checkbox-group>
                    <h3>请选择导出报表的文件格式</h3>
                    <el-radio v-model="ch_export_type2" label="1">excel表格</el-radio>
                    <el-radio v-model="ch_export_type2" label="2">pdf文件</el-radio>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                loading: false,
                shop_list: [],
                room_area_list: [],
                goods_type_list: [],
                ch_list_form: {
                    start_date: '',
                    end_date: '',
                    shop_id: '',
                    room_area: '',
                    room_area_name: '',
                    room_area_disabled: false,
                    goods_type: '',
                    goods_name: '',
                    mobile: '',
				},
				ch_list: [],
				ch_list_page: 1,
                ch_list_total: 0,
                ch_export_sign1: false,
				ch_export_all1: false,
                ch_export_ids1: [],
                ch_export_list1: ['shop_name', 'goods_type_name', 'goods_name', 'goods_unit_name', 'in_quantity', 'out_quantity', 'buying_price', 'buying_price_total'],
                ch_export_type1: '1',
                ch_export_sign2: false,
				ch_export_all2: false,
                ch_export_ids2: [],
                ch_export_list2: ['shop_name', 'goods_type_name', 'goods_name', 'goods_unit_name', 'in_quantity', 'out_quantity', 'buying_price', 'buying_price_total'],
                ch_export_type2: '1',
                ch_sortby: 'goods',
                ch_total_in_quantity: '',
                ch_total_out_quantity: '',
                ch_buying_price_total: '',
            }
        },
        mounted: function() {
            // 日期
            this.ch_list_form.start_date = moment().format('YYYY-MM-DD 08:00');
            this.ch_list_form.end_date = moment().add(1, 'day').format('YYYY-MM-DD 08:00');
            this.innitDate();
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.ch_list_form.shop_id = this.shop_list[0].id;
                this.getGoodsType();
                this.chSortBy('goods');
            })
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.ch_list_form.start_date = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.ch_list_form.end_date = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.ch_list_form.start_date = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.ch_list_form.end_date = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.ch_list_date).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.ch_list_form.start_date = start.format('YYYY-MM-DD 08:00');
                    _this.ch_list_form.end_date = end.format('YYYY-MM-DD 08:00');
                });
            },
            // 初始化门店输入框
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        _this.setShopDefaultTime(_this.shop_list[0].id)
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 获取包厢区域
            getRoomArea: function(shop_id) {
                const _this = this;

                if(shop_id == '') {
                    _this.ch_list_form.room_area = '';
                    _this.ch_list_form.room_area_name = '';
                    _this.ch_list_form.room_area_disabled = true;
                } else {
                    _this.ch_list_form.room_area = '';
                    _this.ch_list_form.room_area_name = '';
                    _this.ch_list_form.room_area_disabled = false;
                    _this.setShopDefaultTime(shop_id)
                    Vue.axios.post('Shop/getRoomArea', {
                        "header": Vue.request_header,
                        "request": {
                            "version": Vue.version,
                            "param": {
                                "shop_id": shop_id
                            }
                        },
                        "comment": ""
                    })
                    .then(res => {
                        if(res.data.response.result_code == "true") {
                            _this.room_area_list = res.data.response.result;
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg('出错啦');
                    });
                }
            },
            // 商品类型
            getGoodsType: function() {
                const _this = this;

                Vue.axios.post('PublicData/api_getGoodsType', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.goods_type_list = res.data.response.result.data;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },



            chRoomArea(val) {
				this.ch_list_form.room_area = val.id;
				this.ch_list_form.room_area_name = val.name;
			},
            getChList(page) {
				const _this = this;

                _this.loading = true;
                let url = "FinanceReport/getConfiscateSumList";
                let data = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.ch_list_form.start_date,
                            "end_date": _this.ch_list_form.end_date,
                            "shop_id": _this.ch_list_form.shop_id,
                            "goods_type": _this.ch_list_form.goods_type,
                            "goods_name": _this.ch_list_form.goods_name,
                            "mobile": _this.ch_list_form.mobile
                        }
                    },
                    "comment": ""
                };
                if(_this.ch_sortby == 'room_area') {
                    url = "FinanceReport/getConfiscateSumListByRoomArea";
                    data.request.param.room_area = _this.ch_list_form.room_area || '';
                }
                Vue.axios({
					method: 'post',
					url: url,
					data: data
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.ch_list_total = Number(res.data.response.result.count);
							_this.ch_total_in_quantity = res.data.response.result.total_in_quantity;
							_this.ch_total_out_quantity = res.data.response.result.total_out_quantity;
							_this.ch_buying_price_total = res.data.response.result.buying_price_total;
						}
						_this.ch_list = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
                });
			},
			// 查询
			chQuery() {
				this.getChList(1);
            },
            // 统计方式
            chSortBy: function(type) {
                const _this = this;

                _this.ch_sortby = type;
                $('.ch-type').removeClass('el-button--primary');
                if(type == 'goods') {
                    $('.ch-type').eq(0).addClass('el-button--primary');
                } else if(type == 'room_area') {
                    $('.ch-type').eq(1).addClass('el-button--primary');
                    _this.ch_list_form.room_area = '';
                    _this.ch_list_form.room_area_name = '';
                    _this.getRoomArea(_this.ch_list_form.shop_id)
                }
                _this.getChList(1);
            },
            // 导出
            chExportAll(val) {
                if(this.ch_sortby == 'goods') {
                    this.ch_export_ids1 = val ? this.ch_export_list1 : [];
                    this.ch_export_sign1 = false;
                } else if(this.ch_sortby == 'room_area') {
                    this.ch_export_ids2 = val ? this.ch_export_list2 : [];
                    this.ch_export_sign2 = false;
                }
			},
			chExportChange(val) {
                const len = val.length;
                if(this.ch_sortby == 'goods') {
                    this.ch_export_all1 = len === this.ch_export_list1.length;
                    this.ch_export_sign1 = len > 0 && len < this.ch_export_list1.length;
                } else if(this.ch_sortby == 'room_area') {
                    this.ch_export_all2 = len === this.ch_export_list2.length;
                    this.ch_export_sign2 = len > 0 && len < this.ch_export_list2.length;
                }
			},
            chExportSet: function() {
                const _this = this;

                let data = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport/sumCommonExport?bill_type=confiscate"
                        }
                    },
                    "comment": ""
                };
                if(_this.ch_sortby == 'room_area') {
                    data.request.param.report_type = 'FinanceReport/confiscateSumListByRoomAreaExport?bill_type=confiscate_area';
                }
                Vue.axios({
					method: 'post',
					url: 'FinanceReport/getExportSet',
					data: data
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(res.data.response.result) {
                            if(_this.ch_sortby == 'goods') {
                                _this.ch_export_ids1 = res.data.response.result.export_fields;
                                _this.ch_export_type1 = res.data.response.result.export_type;
                                _this.chExportChange(_this.ch_export_ids1);
                            } else if(_this.ch_sortby == 'room_area') {
                                _this.ch_export_ids2 = res.data.response.result.export_fields;
                                _this.ch_export_type2 = res.data.response.result.export_type;
                                _this.chExportChange(_this.ch_export_ids2);
                            }
                        } else {
                            if(_this.ch_sortby == 'goods') {
                                _this.ch_export_ids1 = _this.ch_export_list1;
                                _this.ch_export_type1 = '1';
                                _this.chExportChange(_this.ch_export_ids1);
                            } else if(_this.ch_sortby == 'room_area') {
                                _this.ch_export_ids2 = _this.ch_export_list2;
                                _this.ch_export_type2 = '1';
                                _this.chExportChange(_this.ch_export_ids2);
                            }
                        }
					} else {
				        Vue.timeoutfun(res.data.response.result_status, _this);
				        layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
                });
                // 弹窗
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['800px', ''], // 宽高
                    content: $(_this.$refs.ch_list_export)
                }, function() {
                    _this.chExport();
                });
            },
            chExport: function() {
                if(this.ch_sortby == 'goods') {
                    window.location.href = Vue.ctUrl + "FinanceReport/sumCommonExport?bill_type=confiscate&" +
                        "&start_date=" + this.ch_list_form.start_date +
                        "&end_date=" + this.ch_list_form.end_date +
                        "&shop_id=" + this.ch_list_form.shop_id +
                        "&goods_type=" + this.ch_list_form.goods_type +
                        "&goods_name=" + this.ch_list_form.goods_name +
                        "&mobile=" + this.ch_list_form.mobile +
                        "&export_fields=" + JSON.stringify(this.ch_export_ids1) +
                        "&export_type=" + this.ch_export_type1;
                } else if(this.ch_sortby == 'room_area') {
                    window.location.href = Vue.ctUrl + "FinanceReport/confiscateSumListByRoomAreaExport?bill_type=confiscate_area&" +
                        "&start_date=" + this.ch_list_form.start_date +
                        "&end_date=" + this.ch_list_form.end_date +
                        "&shop_id=" + this.ch_list_form.shop_id +
                        "&room_area=" + (this.ch_list_form.room_area || '') +
                        "&room_area_name=" + (this.ch_list_form.room_area_name || '') +
                        "&goods_type=" + this.ch_list_form.goods_type +
                        "&goods_name=" + this.ch_list_form.goods_name +
                        "&mobile=" + this.ch_list_form.mobile +
                        "&export_fields=" + JSON.stringify(this.ch_export_ids2) +
                        "&export_type=" + this.ch_export_type2;
                }
                layer.closeAll();
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scoped>
    
</style>